// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"ff6c173f","227":"ff6c173f","264":"31c58325","290":"0d3a6370","605":"ff6c173f","641":"7e72fbd4","848":"472c6220","926":"ddb203c2","978":"60e997de"}[chunkId] + ".chunk.css";
};